export {
  generateUpdatesForSingleSignup,
  generateUpdatesForObject,
  signupUpdate,
  signupSwapUpdate,
}

function generateUpdatesForSingleSignup( updates, lockoutPrefix, guildPrefix, signups, newsignup, signupsToInvalidate )
{
  if ( newsignup.absent && !newsignup.manualadd ) {
    // If it's an Absence signup, all signups (so incl alts) for this player
    // for this event should be removed
    // (except for the absence-signup, because that will be overwritten anyway)

    var othersignups = signups.filter( s => s.playerid == newsignup.playerid
                                            && s.eventid == newsignup.eventid
                                            && s['.key'] != newsignup['.key']
                                            && !s.absent ) // *
    // *) there was a RaidHelper bug at some point in which there was a duplicate absence
    // for one player for the same event. Without !s.absent they would try to
    // delete each other.

    for( var othersignup of othersignups) {
      updates[ lockoutPrefix + othersignup['.key'] ] = null
      signupsToInvalidate[ othersignup['.key'] ] = false
    }
  }

  // Insert / update the new signup   (individual attributes, to not overwrite team assignment)
  updates[ lockoutPrefix + newsignup['.key'] + '/playerid' ]  = newsignup.playerid
  updates[ lockoutPrefix + newsignup['.key'] + '/eventid' ]   = newsignup.eventid
  updates[ lockoutPrefix + newsignup['.key'] + '/spec' ]      = newsignup.spec
  updates[ lockoutPrefix + newsignup['.key'] + '/name' ]      = newsignup.name
  updates[ lockoutPrefix + newsignup['.key'] + '/timestamp' ] = newsignup.timestamp
  updates[ lockoutPrefix + newsignup['.key'] + '/isprimary' ] = ( newsignup.isprimary ? true : null )
  updates[ lockoutPrefix + newsignup['.key'] + '/tentative' ] = ( newsignup.tentative ? true : null )
  updates[ lockoutPrefix + newsignup['.key'] + '/late' ]      = ( newsignup.late ? true : null )
  updates[ lockoutPrefix + newsignup['.key'] + '/bench' ]     = ( newsignup.bench ? true : null )
  updates[ lockoutPrefix + newsignup['.key'] + '/absent' ]    = ( newsignup.absent ? true : null )
  updates[ lockoutPrefix + newsignup['.key'] + '/valid' ]     = newsignup.valid
  updates[ lockoutPrefix + newsignup['.key'] + '/manualadd' ] = ( newsignup.manualadd ? true : null )

  signupsToInvalidate[ newsignup['.key'] ] = false

  // Guid member update
  if( guildPrefix != '' ) {
    updates[ guildPrefix + newsignup.playerid + '/name' ] = newsignup.name
  }
}

function generateUpdatesForObject( updatesPrefix, obj ) {
  var updates = {}
  Object.keys( obj ).forEach( ( key ) => {
    if( obj[ key ] == undefined ) obj[ key ] = null
    // if( !obj[ key ] ) obj[ key ] = null // don't do this, it screws with reactivity of booleans

    updates[ updatesPrefix + key ] = obj[ key ]
  })
  return updates
}

function appendUpdatesForObject( updates, updatesPrefix, obj ) {
  Object.keys( obj ).forEach( ( key ) => {
    if( obj[ key ] == undefined ) obj[ key ] = null
    // if( !obj[ key ] ) obj[ key ] = null // don't do this, it screws with reactivity of booleans

    updates[ updatesPrefix + key ] = obj[ key ]
  })
  return updates
}

function signupUpdate( db, rootState, signup, newvalues ) {
  let updates = generateUpdatesForObject(
    'lockouts/' + rootState.lockouts.selectedLockout['.key'] +
    '/signups/' + signup['.key'] + '/', newvalues )

  // Mark lockout as no longer up-to-date (for attendance overview)
  updates[ 'destinationLockouts/' + rootState.destinations.selectedDestination['.key'] +
           '/lockouts/' + rootState.lockouts.selectedLockout['.key']
           + '/uptodateattendanceoverview' ] = false

  return db.ref().update( updates )
}

function signupSwapUpdate( db, rootState, signup1, newvalues1, signup2, newvalues2 ) {
  let updates = generateUpdatesForObject(
    'lockouts/' + rootState.lockouts.selectedLockout['.key'] +
    '/signups/' + signup1['.key'] + '/', newvalues1 )
  
  updates = appendUpdatesForObject( updates,
    'lockouts/' + rootState.lockouts.selectedLockout['.key'] +
    '/signups/' + signup2['.key'] + '/', newvalues2 )

  // Mark lockout as no longer up-to-date (for attendance overview)
  updates[ 'destinationLockouts/' + rootState.destinations.selectedDestination['.key'] +
           '/lockouts/' + rootState.lockouts.selectedLockout['.key']
           + '/uptodateattendanceoverview' ] = false

  return db.ref().update( updates )
}
